import * as React from 'react';

import { ReplyTemplateModalCreate } from '../../components/ReplyTemplateModalCreate';
import { ReplyTemplateModalEdit } from '../../components/ReplyTemplateModalEdit';
import { ReplyTemplateModalError } from '../../components/ReplyTemplateModalError';
import { ReplyTemplateModalList } from '../../components/ReplyTemplateModalList';
import { useReplyTemplateModal } from '../../hooks';
import { ERequestApiStatus } from '../../types/appState';
import { EReplyTemplateModalStep } from '../../types/replyTemplates';

export const ReplyTemplateModalContainer = () => {
  const {
    isReplyTemplateModalOpen,
    isReplyTemplateEnabled,
    replyTemplateModalStep,
    replyTemplates,
    replyTemplatesLimit,
    replyTemplateStatus,
    replyTemplateErrorMessage,
    replyTemplateInitialText,
    editableReplyTemplate,
    createReplyTemplate,
    deleteReplyTemplate,
    editReplyTemplate,
    openReplyTemplateModalEdit,
    openReplyTemplateModalCreate,
    closeReplyTemplateModal,
    changeModalStep,
    getReplyTemplates,
    chooseReplyTemplate,
  } = useReplyTemplateModal();

  if (!isReplyTemplateEnabled || !isReplyTemplateModalOpen) {
    return null;
  }

  if (replyTemplateModalStep === EReplyTemplateModalStep.Error) {
    return <ReplyTemplateModalError onClose={closeReplyTemplateModal} onRetry={getReplyTemplates} />;
  }

  if (replyTemplateModalStep === EReplyTemplateModalStep.List) {
    return (
      <ReplyTemplateModalList
        templates={replyTemplates}
        limit={replyTemplatesLimit}
        onClose={closeReplyTemplateModal}
        onDelete={deleteReplyTemplate}
        onChoose={chooseReplyTemplate}
        onEdit={openReplyTemplateModalEdit}
        onCreate={openReplyTemplateModalCreate}
      />
    );
  }

  if (replyTemplateModalStep === EReplyTemplateModalStep.Create) {
    return (
      <ReplyTemplateModalCreate
        initialText={replyTemplateInitialText}
        isLoading={replyTemplateStatus === ERequestApiStatus.Pending}
        errorMessage={replyTemplateErrorMessage}
        onCreate={createReplyTemplate}
        onClose={closeReplyTemplateModal}
      />
    );
  }

  if (replyTemplateModalStep === EReplyTemplateModalStep.Edit && editableReplyTemplate) {
    return (
      <ReplyTemplateModalEdit
        template={editableReplyTemplate}
        onEdit={editReplyTemplate}
        onClose={() => changeModalStep(EReplyTemplateModalStep.List)}
        isLoading={replyTemplateStatus === ERequestApiStatus.Pending}
        errorMessage={replyTemplateErrorMessage}
      />
    );
  }

  return null;
};
